import { createReducer, on } from "@ngrx/store";
import { initialDashboardState, initialFilters } from "./dashboard.state";
import { initializeFiltersData, resetDashboardData, setFiltersSuccess, setCaselogs, setLoadingState, setFiltersData, setWidgetData, setViewToggleKey, setViewToggleConfig, setInstitution, updateConsultTypes, setConsultTypesLoading, setDefaultTimeRange, setFilterCards, setUserDashboards } from "./dashboard.actions";
import { cloneDeep } from "lodash";
import { VIEW_TOGGLE_KEYS } from "src/app/core/data/constants";
import { DateTimeHelper } from "src/app/core/helpers/date-time";

const optionsMap = {
    hospital: 'hospitals',
    provider: 'providers',
    diagnosis: 'diagnosis',
    consultType: 'consultTypes'
}

const filtersWithAllKey = ['provider', 'diagnosis'];

const _dashboardReducer = createReducer(
    initialDashboardState,
    on(setFiltersSuccess, (state, action) => {
        return {
            ...state,
            filters: cloneDeep(action.filters)
        }
    }),
    on(initializeFiltersData, (state, action) => {
        // Form object with key and defaultValue
        const defaultFilters = action?.filtersData?.reduce((acc, filter) => {
            if(filter?.defaultValue) acc[filter?.name] = filter?.defaultValue;
            return acc;
        }, {});


        const existingTimeValues = {
            startTime: state.filters?.startTime,
            endTime: state.filters?.endTime
        };



        let updatedFilters = {
            ...initialFilters,
            ...defaultFilters
        };

        const timeToUse = (existingTimeValues.startTime && existingTimeValues.endTime)
            ? { startTime: existingTimeValues.startTime, endTime: existingTimeValues.endTime }
            : state.defaultTimeRange || { startTime: '', endTime: '' };

        const computedRange = updatedFilters.dateRange
            ? DateTimeHelper.getDateRange(updatedFilters.dateRange)
            : null;

        updatedFilters = {
            ...updatedFilters,
            startDate: computedRange ? `${computedRange.startDate} ${timeToUse.startTime}` : updatedFilters.startDate,
            endDate: computedRange ? `${computedRange.endDate} ${timeToUse.endTime}` : updatedFilters.endDate,
            startTime: timeToUse.startTime,
            endTime: timeToUse.endTime
        };


        return {
            ...state,
            filters: updatedFilters,
            filtersData: action?.filtersData?.map(filter => {
                if(Object.keys(optionsMap)?.includes(filter?.name)) {
                    const options = filtersWithAllKey?.includes(filter?.name) ? [
                        {
                            label: 'All',
                            value: 'all'
                        }
                        ,...(action?.[optionsMap[filter?.name]] ?? [])
                    ] : action?.[optionsMap[filter?.name]]
                    return {
                        ...filter,
                        options
                    }
                }
                return {...filter};
            }),
            consultTypes: action?.consultTypes || []
        };
    }),
    on(setFiltersData, (state, action) => {
        return {
            ...state,
            filtersData: cloneDeep(action.filtersData)
        };
    }),
    on(updateConsultTypes, (state, action) => {
        return {
            ...state,
            consultTypes: action.consultTypes,
            isConsultTypesLoading: false,
            filtersData: state.filtersData.map(filter => {
                if (filter.name === 'consultType') {
                    return {
                        ...filter,
                        options: action.consultTypes
                    };
                }
                return filter;
            })
        };
    }),
    on(setCaselogs, (state, action) => {
        const { data } = action;
        return {
            ...state,
            caselogs: [...data.caselogs],
            totalCaselogs: data.total,
            paginationMeta: data.paginationMeta,
        };
    }),
    on(setLoadingState, (state, action) => {
        const { isLoading } = action;
        return {
            ...state,
            isLoading
        };
    }),
    on(setWidgetData, (state, action) => {
        const { widgetData } = action;
        return {
            ...state,
            widgetData: {
                ...state.widgetData,
                ...widgetData
            }
        };
    }),
    on(setViewToggleConfig, (state, action) => {
        return {
            ...state,
            viewToggleConfig: action?.config
        };
    }),
    on(setViewToggleKey, (state, action) => {
        return {
            ...state,
            viewToggleConfig: { ...state.viewToggleConfig, selectedKey: action.key as VIEW_TOGGLE_KEYS }
        };
    }),
    on(setInstitution, (state, action) => {
        return {
            ...state,
            institution: action?.institution
        };
    }),
    on(resetDashboardData, (state) => {
        return {
            ...initialDashboardState,
            institution: state.institution,
            defaultTimeRange: state.defaultTimeRange
        };
    }),
    on(setConsultTypesLoading, (state, action) => {
        return {
            ...state,
            isConsultTypesLoading: action.isLoading
        };
    }),
    on(setDefaultTimeRange, (state, action) => {
        return {
            ...state,
            defaultTimeRange: action.timeRange
        };
    }),
    on(setFilterCards, (state, action) => {
        return {
            ...state,
            filterCards: action.filterCards
        };
    }),
    on(setUserDashboards, (state, action) => {
        return {
            ...state,
            userDashboards: action.dashboards || []
        };
    })
);

export function dashboardReducer(state, action) {
    return _dashboardReducer(state, action);
}